const config = {
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://fxfh6ltv7h.execute-api.us-east-1.amazonaws.com/prod",
  },
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_3M6Sg7VzX",
    APP_CLIENT_ID: "27rql93qpb5oe99dp9a5uhrrq1",
    IDENTITY_POOL_ID: "us-east-1:cc0443cf-1083-49bc-970e-d3345470e523",
  },
};

export default config;
